import { render, staticRenderFns } from "./ContainerView.vue?vue&type=template&id=b6ae2392&scoped=true&lang=html&"
import script from "./ContainerView.vue?vue&type=script&lang=js&"
export * from "./ContainerView.vue?vue&type=script&lang=js&"
import style0 from "./ContainerView.vue?vue&type=style&index=0&id=b6ae2392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ae2392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VRow})
